import { render, staticRenderFns } from "./TemplateAssets.vue?vue&type=template&id=55483054"
import script from "./TemplateAssets.vue?vue&type=script&lang=js"
export * from "./TemplateAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports